import enums from "./../enums";

const match = (
	state = {
		couponLoading: false,
		oddLoading: false,

		odds: {
			content: [],
		},
	},
	action
) => {
	switch (action.type) {
		case enums.ODDS: {
			return { ...state, odds: action.payload };
		}

		case enums.LOADING_ODD: {
			return { ...state, oddLoading: action.payload };
		}
		default:
			return { ...state };
	}
};

export default match;
